import styled from 'styled-components';

import { SquaredButton } from 'elements';

export const AddToCartBulkStyled = styled(SquaredButton)`
  margin-top: 0.8rem;
`;
